// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"k_m","cross":"k_C","crossIcon":"k_D"};